/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { subscriptionUpdateInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmSubscriptionUpdateResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetSubscriptions Input Action
 */
export class SubscriptionUpdateInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `ISubscriptionUpdateInput`;
    public getCacheObjectType = () => 'ISubscriptionUpdateInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ISubscriptionUpdateData extends IrsmSubscriptionUpdateResponse { }

export interface IInputRequirements {
    subscriptionId: string;
    subscriptionName: string;
    nextOrderDate: string;
    addressId: string;
    customerId?: string;
    frequency: string;
    cardId: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
export const createSubscriptionUpdateInput = (
    args: Msdyn365.ICreateActionContext,
    {
        subscriptionId,
        subscriptionName,
        nextOrderDate,
        addressId,
        customerId,
        cardId,
        frequency
    }: IInputRequirements
): SubscriptionUpdateInput => {
    const accNumber = args.requestContext.user.customerAccountNumber || customerId;
    return new SubscriptionUpdateInput(
        subscriptionUpdateInput(subscriptionId, subscriptionName, nextOrderDate, addressId, frequency, accNumber!, cardId)
    );
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function subscriptionUpdateAction(input: SubscriptionUpdateInput, ctx: Msdyn365.IActionContext): Promise<ISubscriptionUpdateData> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISubscriptionUpdateData>>subscriptionUpdateAction,
    input: createSubscriptionUpdateInput
});
